import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=0c5edc98&scoped=true&"
import script from "./ProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=0c5edc98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5edc98",
  null
  
)

export default component.exports